import type { MeetingNextStep } from "@care-by-ella/contracts";

// TES-537 (A-02) — the four "Nästa steg efter vårdmötet" choices, the exact
// wording of the canonical brief, plus what each one sets in motion so the
// doctor sees the consequence before she picks.
export const NEXT_STEP_LABELS: Record<
  MeetingNextStep,
  { title: string; effect: string }
> = {
  upload_existing_labs: {
    title: "Befintliga provsvar behöver laddas upp",
    effect: "Patienten får CP-06 med uppladdning + blodtryck/puls.",
  },
  new_blood_test: {
    title: "Nytt blodprov krävs",
    effect: "Patienten får CP-06 med nytt blodprov + blodtryck/puls.",
  },
  labs_verified_trusted_source: {
    title: "Befintliga provsvar är redan verifierade i betrodd vårdkälla",
    effect: "Patienten får CP-06 med endast blodtryck/puls; behandlingsbeslut kan gå vidare.",
  },
  cannot_proceed: {
    title: "Patienten kan inte gå vidare",
    effect: "Ingen CP-06 — det negativa beslutsflödet.",
  },
};
